export * from './berichte-list.component';
export * from './berichte-list.component.module';